import {
  flexRender,
  getCoreRowModel,
  getExpandedRowModel,
  getFilteredRowModel,
  getGroupedRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { useVirtualizer } from "@tanstack/react-virtual";

import { useCallback, useEffect, useRef, useState } from "react";
import { AiOutlineArrowDown, AiOutlineArrowUp } from "react-icons/ai";
import { VscGroupByRefType } from "react-icons/vsc";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { Addition } from "../../../CommonFunction/CalculationsWithDecimalValues";
import { NumberFormatter } from "../../../CommonFunction/common";
import pathState from "../../../atoms/pathstate";
import { useSelectiveEffect } from "../../custom_hooks/useSelectiveEffect";
import DragDiv from "../DragDiv/DragDiv";
import { WarningToast } from "../ToastComponent/RectHotToast";
import {
  AtomstateCallback,
  AtomstateCallbackFilter,
  GetTableHeaders,
  Render_edit_cell,
  extractIds,
  handleKeyDown1,
} from "./Tablefunctions";
import "./VirtualTable.scss";
import { CheckboxFilterBox, IndeterminateCheckbox, TableRow } from "./VirtualTableComponents";
import TableOptions from "./VirtualTableComponents/TableOptions";

//normalize helper strip non-alphanumerics an lowercase
const normalize = (str) =>
  String(str ?? "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");

const globalFilterFn = (row, columnId, filterValue) => {
  const normFilter = normalize(filterValue);
  return Object.values(row.original).some((value) => normalize(value).includes(normFilter));
};

const initialTableSelectionState = {
  Selected_Row: {},
  Selected_Rows: [],
  SelRow_id: [],
  SelRows_ids: [],
};
const VirtualTable = ({
  data,
  title,
  TypeOfPortal = "",
  ledgerTable,
  selectedRows,
  multiSelect = true,
  dragDrop,
  settings = true,
  options = true,
  select = true,
  tab = "",
  SelectCheckbox = true,
  colAddition = [],
  TableHeaders = [],
  onRowSelect = () => {},
  InitialGrouping = false,
  GroupValues = [],
  ModalTable = false,
  onExportExcel = undefined,
  resetFiltersOnUnmount = false,
  onDoubleClick = undefined,
}) => {
  let Action = TypeOfPortal;
  // console.log(TableHeaders);
  const tableContainerRef = useRef(null);
  const [{ currentPath, previousPath, PerviousTitle, CurrentTitle }, setPaths] = useRecoilState(pathState);
  const pathSegments = currentPath.split("/");
  const pathId = pathSegments[pathSegments.length - 2];
  const dispatch = useDispatch();
  const [filters, setFilters] = useRecoilState(AtomstateCallback(tab ? title + tab : title));
  console.log(filters, "filtersfiltersfiltersfiltersfilters11111111111");
  const [TableSelectionData, SetTableSelectionData] = useState(initialTableSelectionState);
  const [tableData, setTableData] = useState(data);
  const [DataChanged, SetDataChenged] = useState(false);
  const [sorting, setSorting] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [rowSelection, setRowSelection] = useState({});
  const [columnsTotal, setColumnTotal] = useState(colAddition);
  const [columnsView, setColumnView] = useState(colAddition);
  const tableCols = !select
    ? ["srNo", ...Object.keys(data[0]).filter((key) => key !== "_id")]
    : ["select", ...Object.keys(data[0]).filter((key) => key !== "_id")];
  const [AppliedFilter, setAppliedFilter] = useRecoilState(
    AtomstateCallbackFilter("Filter" + (tab ? title + tab : title))
  );

  const [activeCell, setActiveCell] = useState(`0_${tableCols[1]}`);
  const [activeCellCoords, setActiveCellCoords] = useState({
    rowIndex: 0,
    colKey: tableCols[1],
  });
  const [toggle_TypeOfPortal, setToggleTypeOfPortal] = useState({ toggle: false, TypeOfPortal });
  const [fielddata, setfielddata] = useState({});

  //for grouping  the state values
  const [grouping, setGrouping] = useState([...GroupValues]);

  const [isgrouping, setIsGrouping] = useState(InitialGrouping);
  const [expanded, setExpanded] = useState({});
  const [showTableOptns, setShowTableOpts] = useState(false);
  const navigate = useNavigate();
  const onChange_From_Date = JSON.parse(sessionStorage.getItem("SelectedFromDate"));
  const onChange_To_Date = JSON.parse(sessionStorage.getItem("SelectedToDate"));

  useEffect(() => {
    if (TableHeaders.length) {
      const updatedTotal = TableHeaders?.map((el) => el[2])?.filter((val) => val !== null);
      // console.log(TableHeaders);
      const TabelView = TableHeaders?.filter((item) => item[3] === false).map((item) => item[0]); // keep only those with 4th element === false

      // console.log(updatedTotal, "updatedTotalupdatedTotalupdatedTotal");
      setColumnTotal(updatedTotal);
      setColumnView(TabelView);
    }
  }, [TableHeaders]);

  useEffect(() => {
    if (selectedRows?.length > 0) {
      const newSelection = {};
      selectedRows.forEach((selectedRow) => {
        const rowIndex = tableData.findIndex((dataRow) => dataRow._id === selectedRow._id);
        const row = tableData.find((dataRow) => dataRow._id === selectedRow._id);
        if (rowIndex > -1) {
          newSelection[row?._id] = true;
        }
      });

      if (JSON.stringify(newSelection) !== JSON.stringify(rowSelection)) {
        setRowSelection(newSelection);
      }
    }
  }, [selectedRows, tableData]);

  useEffect(() => {
    if (previousPath !== currentPath || title !== PerviousTitle) {
      const initialFilters = {};
      Object.keys(tableData?.[0])?.map((item) => {
        initialFilters[item] = [];
      });
      console.log(initialFilters, "prevFilter0");
      setFilters(initialFilters);

      setPaths({
        previousPath: currentPath,
        currentPath,
        PerviousTitle: CurrentTitle,
        CurrentTitle: title,
      });
      if (SelectCheckbox)
        dispatch({
          type: "UNIQUE_TABLE_LATEST_TITLE",
          payload: { title: title },
        });
    }
    // tableContainerRef.current.focus();
    if (previousPath !== currentPath) {
      dispatch({ type: "CLEAR_UNIQUE_TABLE_LIST", payload: {} });
    }
  }, [title]);
  useEffect(() => {
    return () => {
      if (ModalTable || resetFiltersOnUnmount) {
        const initialFilters = {};
        Object.keys(tableData?.[0])?.map((item) => {
          initialFilters[item] = [];
        });
        console.log("prevFilter-1");
        setFilters(initialFilters);
      }
    };
  }, [ModalTable, resetFiltersOnUnmount]);

  useSelectiveEffect(
    () => {
      if (tab !== "") {
        const initialFilters = {};
        Object.keys(tableData?.[0])?.map((item) => {
          initialFilters[item] = [];
        });
        console.log(initialFilters, "prevFilter-2");
        setFilters(initialFilters);
        setRowSelection({});
      }
    },
    [tab],
    [tableData]
  );

  useEffect(() => {
    const payloadData = { key: title, data: TableSelectionData };
    dispatch({ type: "UNIQUE_TABLE_LIST", payload: payloadData });
  }, [TableSelectionData]);

  useEffect(() => {
    if (previousPath !== currentPath && SelectCheckbox) {
      dispatch({
        type: "UNIQUE_TABLE_LATEST_TITLE",
        payload: { title: title },
      });
    }
  }, [previousPath, currentPath, title]);

  useEffect(() => {
    if (title.includes("New Branches")) {
      let CompanyId = title.split(" ")[0];
      dispatch({
        type: "MultiSelectedRows",
        payload: {
          compId: CompanyId,
          branchIds: table.getSelectedRowModel().rows,
        },
      });
    }
  }, [rowSelection]);
  const prevRowSelectionRef = useRef();

  useEffect(() => {
    const prevRowSelection = prevRowSelectionRef.current;

    if (prevRowSelection !== rowSelection) {
      if (Object.keys(rowSelection).length > 0) {
        const datarows = table.getSelectedRowModel().rows;
        const SelectedRows = datarows.map((row) => row.original)?.reverse();

        const SelectSingleRow = datarows[0]?.original || {};
        const idsdata = {
          SelRow_id: extractIds([SelectSingleRow]),
          SelRows_ids: extractIds(SelectedRows),
        };

        // Update your state here
        SetTableSelectionData((prevState) => ({
          ...prevState,
          Selected_Rows: SelectedRows,
          Selected_Row: SelectSingleRow,
          ...idsdata,
        }));
      } else {
        SetTableSelectionData(initialTableSelectionState);
      }

      // Update the ref after handling your logic to ensure it tracks the latest value
      prevRowSelectionRef.current = rowSelection;
    }
    // You only want to trigger this effect when `rowSelection` changes.
    // Other dependencies like SetTableSelectionData should not cause this effect to rerun.
  }, [rowSelection]);
  useEffect(() => {
    setTableData(data);
    SetDataChenged(true);
  }, [data]);

  const handleRowSelectionChange = (rowId) => {
    setRowSelection((prevSelection) => {
      const newSelection = multiSelect ? { ...prevSelection } : {};
      if (newSelection[rowId]) {
        delete newSelection[rowId]; // Deselect the row
      } else {
        newSelection[rowId] = true; // Select the row
      }
      return newSelection;
    });
  };

  const columns = !select
    ? [
        {
          id: "srNo",
          accessorKey: "srNo",
          header: "Sr. ",
          cell: ({ row }) => row.index + 1,
          sticky: "left",
          enableGrouping: false,
          enableSorting: false,
        },
        ...Object.keys(data ? data[0] : {}).map((item) => ({
          accessorKey: item,
          header: item.split("_").join(" "),
        })),
      ]
    : [
        {
          id: "select",
          accessorKey: "select", // assuming data has 'select' key for checkboxes
          header: ({ table }) => (
            <IndeterminateCheckbox
              checked={table.getIsAllRowsSelected()}
              onChange={table.getToggleAllRowsSelectedHandler()}
              indeterminate={table.getIsSomeRowsSelected()}
            />
          ),
          cell: ({ row }) => (
            <IndeterminateCheckbox
              checked={rowSelection[row?.original?._id] || false}
              onChange={() => handleRowSelectionChange(row?.original?._id, row)}
            />
          ),
          sticky: "left", // Make this column always stick to the left
          enableGrouping: false, // Disable grouping for this column
        },

        ...GetTableHeaders({ tableData: data, TableHeaders })
          .filter((key) => key !== "select")
          .map((item) => ({
            accessorKey: item[0],
            header: item[1]?.split("_")?.join(" "),
          })),
      ];

  const table = useReactTable({
    data: tableData,
    columns: columns,
    getRowId: (row) => row._id, // Use unique _id as row ID
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(), // Ensure this uses globalFilter effectively
    state: {
      globalFilter, // This should be part of the state to ensure it updates the view
      grouping,
      expanded,
      sorting,
      rowSelection,
    },
    onGroupingChange: setGrouping,
    onExpandedChange: setExpanded,
    getGroupedRowModel: getGroupedRowModel(),
    getExpandedRowModel: getExpandedRowModel(),
    onSortingChange: setSorting,
    onGlobalFilterChange: setGlobalFilter,
    columnResizeMode: "onChange",
    enableMultiSort: true,
    globalFilterFn,
    onRowSelectionChange: useCallback(
      (newRowSelection) => {
        const data = newRowSelection(); // Correct usage: newRowSelection is an object
        if (!multiSelect) {
          const updatedSelection = {};

          // Loop through selected rows and map the _id to the selection state
          Object.keys(newRowSelection).forEach((rowIndex) => {
            const row = tableData[rowIndex];
            if (row && row._id) {
              updatedSelection[row._id] = newRowSelection[rowIndex];
            }
          });

          setRowSelection(updatedSelection); // Update the selection state
        } else {
          setRowSelection(newRowSelection);
        }
      },
      [multiSelect, tableData]
    ),
  });
  console.log(table.getHeaderGroups(), "table.getHeaderGroups()table.getHeaderGroups()");
  const { rows } = table.getRowModel();
  // console.log(rows)
  // List virtualization
  const rowVirtualizer = useVirtualizer({
    // Return the scrolling container element (tableContainerRef)
    getScrollElement: () => tableContainerRef.current,
    // Number of items (rows) to virtualize
    count: rows?.length || 0,
    // Estimate the size of each item (row) in pixels
    estimateSize: () => 40,
    // Optional overscan to render extra items before/after current view
    overscan: 30,
  });

  const hanleTableOptions = () => {
    setShowTableOpts(!showTableOptns);
  };
  const handleChangeTableOptions = (event, type) => {
    if (type === "GROUP_BY") {
      setIsGrouping(!isgrouping);
    }
  };
  const virtualRows = rowVirtualizer.getVirtualItems();

  const totalSize = rowVirtualizer.getTotalSize();

  const paddingTop = virtualRows?.length > 0 ? virtualRows[0]?.start : 0;
  const paddingBottom = virtualRows?.length > 0 ? totalSize - (virtualRows[virtualRows.length - 1]?.end || 0) : 0;

  // Footer count
  table.getAllColumns()[0].columnDef.footer = rows?.length; // Set the row count for the first column (Sr. No or select)

  columnsTotal?.forEach((colKey) => {
    const column = table.getAllColumns().find((col) => col.id === colKey);
    if (column) {
      const total = rows?.reduce((acc, row) => {
        const value = tableData[row.index][colKey];
        // console.log(value ,typeof value, "typeof valuetypeof valuetypeof valuetypeof value")
        if (typeof value !== "number") {
          return acc;
        }
        return Addition(acc, typeof value === "number" ? value : 0);
      }, 0);
      column.columnDef.footer = total;
    }
  });

  const getloadfun = (row) => {
    // debugger
    if (
      title === "All SPs" ||
      title === "LRTable" ||
      title === "LR_Data" ||
      title === "New_Branches" ||
      title === "Pickup Memo"
    ) {
      return;
    }

    const datarows = [row];
    const SelectedRows = datarows.map((row) => row.original);

    const SelectSingleRow = datarows[0]?.original || {};
    // console.log(SelectSingleRow)
    if (SelectSingleRow?.Is_Lock) {
      Action = "View";
      // console.log(Action)
      WarningToast("Entry is Lock!");
      // return;
    }

    const idsdata = {
      SelRow_id: extractIds([SelectSingleRow]),
      SelRows_ids: extractIds(SelectedRows),
    };

    SetTableSelectionData({
      Selected_Rows: SelectedRows,
      Selected_Row: SelectSingleRow,
      ...idsdata,
    });
    if (onDoubleClick) {
      onDoubleClick({
        Selected_Rows: SelectedRows,
        Selected_Row: SelectSingleRow,
        ...idsdata,
      });
    }

    setfielddata(row);
    setTimeout(() => {
      setToggleTypeOfPortal({ toggle: true, TypeOfPortal: SelectSingleRow?.Is_Lock ? "View" : TypeOfPortal });
    }, 1);

    if (title === "Receivable" || title === "Payable") {
      navigate(`/${title}/NewRef/${row.original._id}`);
    } else if (
      title === "Receivable_Account_Bill_By_Bill_Detail_View" ||
      title === "Payable_Account_Bill_By_Bill_Detail_View"
    ) {
      dispatch({
        type: "UNIQUE_TABLE_LIST",

        payload: {
          key: "Account_Vouchers",
          data: {
            Selected_Rows: [row.original],
            Selected_Row: row.original,
            SelRow_id: row.original?._id,
            SelRow_ids: [row.original?._id],
          },
        },
      });
      navigate(`/${title}/NewRef/AgainstRef/${row.original._id}`);
    } else if (title === "Account_Ledger") {
      navigate(`/Ledger/${pathId}/${row.original?._id}`, {
        state: {
          monthData: SelectSingleRow,
        },
      });
    } else if (["Ledger_Data", "TrailBalance", "TrailOpeningBalances"].includes(title)) {
      const id = row.original?._id;
      navigate(`/Ledger/${id}/monthly`);
    } else if (title === "Account_Check") {
      navigate("/MonthlyAccountBalanceChecks", {
        state: {
          monthlyAccountBalanceData: {
            previous: SelectSingleRow.monthlyBalances,
            afterCheck: SelectSingleRow.monthlyBalances,
          },
        },
      });
    } else if (["Stock_Item_Sales_Report"].includes(title)) {
      const id = row.original?._id;
      let From_Date = JSON.parse(sessionStorage.getItem("SelectedFromDate"));
      let To_Date = JSON.parse(sessionStorage.getItem("SelectedToDate"));

      if (onChange_From_Date !== From_Date) {
        From_Date = onChange_From_Date;
      }
      if (onChange_To_Date !== To_Date) {
        To_Date = onChange_To_Date;
      }

      if (SelectSingleRow.Voucher_Type === "Sales Bill") {
        navigate(`/salesItemReport/${id}`, {
          state: {
            requestData: {
              id: id,
              itemValue: SelectSingleRow.Item_Value,
              voucherType: SelectSingleRow.Voucher_Type,
            },
            dateFilter: {
              From_Date,
              To_Date,
            },
          },
        });
      } else {
        navigate(`/purchaseItemReport/${id}`, {
          state: {
            requestData: {
              id: id,
              itemValue: SelectSingleRow.Item_Value,
              voucherType: SelectSingleRow.Voucher_Type,
            },
            dateFilter: {
              From_Date,
              To_Date,
            },
          },
        });
      }
    }

    return {
        Selected_Rows: SelectedRows,
        Selected_Row: SelectSingleRow,
        ...idsdata,
      }
  };

  //getting the ID from current Path
  const baseClass = "table-container";
  const additionalClasses = [
    ledgerTable ? "ledgerTable" : "",
    title === "L.R.List For Bill" ? "LRContainer" : "",
    title.includes("POD") || title.includes("Booking") || title.includes("Load") ? "PODTable" : "",
  ]
    .filter(Boolean)
    .join(" ");
  // whenever you add a grouping, open all groups by default
  useEffect(() => {
    if (grouping.length > 0) {
      table.toggleAllRowsExpanded(true);
      // console.log(grouping, "groupinggroupinggroupinggrouping")
    }
  }, [grouping, table]);

  return (
    <>
      {dragDrop && (
        <DragDiv
          data={tableData}
          setglobelFilter={(value) => {
            setGlobalFilter(value?.toString());
          }}
          hanleTableOptions={hanleTableOptions}
          settings={settings}
          options={options}
          title={title}
          onExportExcel={onExportExcel}
        />
      )}

      <div
        id={title}
        ref={tableContainerRef}
        className={`${baseClass} ${additionalClasses}`}
        tabIndex={1}
        key={tab}
        onKeyDown={(event) =>
          handleKeyDown1(
            event,
            toggle_TypeOfPortal?.toggle,
            activeCellCoords,
            tableCols,
            rows,
            tableData,
            getloadfun,
            setActiveCellCoords,
            setActiveCell,
            tableContainerRef
          )
        }
      >
        <table>
          <thead>
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header, index) => {
                  return (
                    (header.column.id === "select" || header.column.id === "srNo") && (
                      <th
                        key={header.id}
                        colSpan={header.colSpan}
                        style={{
                          width: header.getSize() !== 150 ? header.getSize() : ``,
                          zIndex: index + 1,
                        }}
                      >
                        <div className="column-content">
                          <span onClick={header.column.getToggleSortingHandler()}>
                            {flexRender(header.column.columnDef.header, header.getContext())}
                          </span>
                        </div>
                        <div
                          onMouseDown={header.getResizeHandler()}
                          onTouchStart={header.getResizeHandler()}
                          className={`resize-div ${header.column.getIsResizing() ? "isResizing" : ""}`}
                        />
                      </th>
                    )
                  );
                })}

                {headerGroup.headers.map((header, index) => {
                  return (
                    header.id !== "_id" &&
                    header.id !== "id" &&
                    !columnsView.includes(header.id) &&
                    header.column.id !== "select" &&
                    header.column.id !== "srNo" && (
                      <th
                        key={header.id}
                        colSpan={header.colSpan}
                        style={{
                          width: header.getSize() !== 150 ? header.getSize() : ``,
                          zIndex: index + 1,
                        }}
                      >
                        <div className="column-content">
                          {header.column.getCanGroup() && isgrouping && (
                            <span onClick={header.column.getToggleGroupingHandler()} style={{ cursor: "pointer" }}>
                              {header.column.getIsGrouped() ? "🛑" : <VscGroupByRefType style={{ marginTop: "3px" }} />}
                            </span>
                          )}

                          <span onClick={header.column.getToggleSortingHandler()}>
                            {flexRender(header.column.columnDef.header, header.getContext())}
                            {
                              {
                                asc: <AiOutlineArrowUp size={14} className="sort-icon" />,
                                desc: <AiOutlineArrowDown size={14} className="sort-icon" />,
                              }[header.column.getIsSorted() ?? null]
                            }
                          </span>
                          <CheckboxFilterBox
                            field={header.column.id}
                            tableData={tableData}
                            setTableData={setTableData}
                            index={index}
                            data={data}
                            filters={filters}
                            setFilters={setFilters}
                            AppliedFilter={AppliedFilter}
                            setAppliedFilter={setAppliedFilter}
                            Tab={tab}
                            SetDataChenged={SetDataChenged}
                            DataChanged={DataChanged}
                            columnsView={columnsView}
                          />
                        </div>
                        <div
                          onMouseDown={header.getResizeHandler()}
                          onTouchStart={header.getResizeHandler()}
                          className={`resize-div ${header.column.getIsResizing() ? "isResizing" : ""}`}
                        />
                      </th>
                    )
                  );
                })}
              </tr>
            ))}
          </thead>
          <tbody>
            {/* Top spacing */}
            {paddingTop > 0 && <tr style={{ height: paddingTop }}></tr>}

            {virtualRows?.map((virtualRow, index) => {
              const row = rows[virtualRow.index];
              const isRowSelected = table
                .getSelectedRowModel()
                .flatRows.some((selectedRow) => selectedRow.original === row.original);
              return (
                <TableRow
                  key={index}
                  setActiveCell={setActiveCell}
                  activeCell={activeCell}
                  setActiveCellCoords={setActiveCellCoords}
                  isRowSelected={isRowSelected}
                  row={row}
                  title={title}
                  onDoubleClick={() => getloadfun(row)}
                  columnsView={columnsView}
                />
              );
            })}
            {tableData.length === 0 && (
              <tr>
                <td colSpan={columns.length} style={{ textAlign: "center" }}>
                  No data available.
                </td>
              </tr>
            )}

            {/* Bottom spacing */}
            {paddingBottom > 0 && <tr style={{ height: paddingBottom }}></tr>}
          </tbody>
          <tfoot style={!select ? {} : { zIndex: rows?.length <= 20 ? -1 : 1 }} className="table_footer">
            {table.getFooterGroups().map((footerGroup) => (
              <tr key={footerGroup.id}>
                {footerGroup.headers.map((footer, index) => {
                  const { footer: footerValue } = footer.column.columnDef;
                  return (
                    footer.column.id !== "id" &&
                    footer.column.id !== "_id" &&
                    !columnsView.includes(footer.column.id) && (
                      // footer.column.id !== "srNo" &&
                      <th
                        key={footer.id}
                        colSpan={footer.colSpan}
                        style={{
                          textAlign: index === 0 ? "center" : typeof footerValue === "number" ? "right" : "left",
                        }}
                      >
                        {columnsTotal?.includes(footer.column.id) && index !== 0 && typeof footerValue === "number"
                          ? NumberFormatter(flexRender(footer.column.columnDef.footer, footer.getContext()))
                          : (index === 0 && select) || footer.column.id === "srNo"
                          ? footerValue
                          : ""}
                      </th>
                    )
                  );
                })}
              </tr>
            ))}
          </tfoot>
        </table>
      </div>
      {showTableOptns && (
        <TableOptions
          show={showTableOptns}
          hanleTableOptions={hanleTableOptions}
          title={title}
          handleChangeTableOptions={handleChangeTableOptions}
          isgrouping={isgrouping}
        />
      )}
      {/* edit model popup  we we double click on any place in table row */}
      {Render_edit_cell(toggle_TypeOfPortal, setToggleTypeOfPortal, getloadfun, title,TableSelectionData)}
    </>
  );
};

export default VirtualTable;
